
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-16" style={{ backgroundColor: '#F8F4EF' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 mb-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
            {/* Column 1: NextPhase Workflows */}
            <div>
              <h3 
                className="text-xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                NextPhase Workflows
              </h3>
              <ul className="space-y-3">
                <li>
                  <Link 
                    to="/"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/services/workflow-system-architecture"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/#pricing"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Pricing
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/estimate"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Estimate
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/#contact"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 2: Client Resources */}
            <div>
              <h3 
                className="text-xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Client Resources
              </h3>
              <ul className="space-y-3">
                <li>
                  <Link 
                    to="/client-billing-portal"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Client Billing Portal
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/get-started"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Get Started
                  </Link>
                </li>
                <li>
                  <a 
                    href="https://calendly.com/david-nextphaseworkflows/workflow-audit"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Schedule Audit
                  </a>
                </li>
                <li>
                  <a 
                    href="mailto:david@nextphaseworkflows.com"
                    className="transition-colors duration-200 cursor-pointer hover:opacity-80"
                    style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                  >
                    Support Email
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3: Company */}
            <div>
              <h3 
                className="text-xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Company
              </h3>
              <div 
                className="leading-relaxed"
                style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
              >
                <p className="mb-2 font-semibold">NextPhase Workflows LLC</p>
                <p className="mb-2">Based in Michigan</p>
                <p>Operational Automation for Organizations and Teams.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright Bar */}
        <div className="border-t pt-6" style={{ borderColor: '#E6DACD' }}>
          <p 
            className="text-center text-sm"
            style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
          >
            © NextPhase Workflows LLC — All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
